var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1102_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19414 10.9163C8.19414 10.3818 8.60947 9.93782 9.12862 9.93782L20.0569 9.93782C20.5761 9.93782 21 10.3818 21 10.9163C21 11.4508 20.5761 11.9038 20.0569 11.9038L9.13728 11.9038C8.61812 11.9038 8.20279 11.4599 8.20279 10.9163L8.19414 10.9163Z",
    fill: "#243D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44139 4.1126C7.07798 3.73208 7.07798 3.10695 7.44139 2.71737L7.6404 2.509C8.00381 2.12849 8.64411 2.08318 8.99887 2.4637C9.18057 2.65396 9.27575 2.89858 9.27575 3.15226C9.27575 3.40593 9.18057 3.6596 8.99887 3.84986L8.75659 4.10353C8.39318 4.48404 7.79615 4.48404 7.43274 4.10353L7.44139 4.1126Z",
    fill: "#243D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.02491e-06 10.9164C-5.00471e-06 10.6627 0.0951755 10.4091 0.268228 10.2279L4.7849 5.49865C5.14831 5.11814 5.74534 5.11814 6.11741 5.49865C6.48082 5.87917 6.48082 6.50429 6.11741 6.89386L2.26699 10.9255L9.00739 17.9921C9.18909 18.1733 9.28427 18.418 9.28427 18.6807C9.28427 18.9434 9.18909 19.188 9.00739 19.3783C8.83433 19.5595 8.60071 19.6682 8.34979 19.6682C8.09886 19.6682 7.86524 19.5595 7.68353 19.3783L0.268228 11.614C0.0951754 11.4328 -5.04584e-06 11.1792 -5.02491e-06 10.9164Z",
    fill: "#243D63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1102_1145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcLeftarrow);
export default __webpack_public_path__ + "static/media/LCLeftarrow.a5ebd496ac02c8969c063d5e778291d2.svg";
export { ForwardRef as ReactComponent };